module.exports = __webpack_public_path__ + "images/category_lp/brand_samples/pattern_new2/pc/fv_base_58f288a3257e34a8e1d1f9df1b83178e.png";